/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var XPATH_A = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,34,35],$V1=[2,11],$V2=[1,6],$V3=[1,7],$V4=[5,6],$V5=[1,12],$V6=[1,13],$V7=[28,29,30,31,32,34,35],$V8=[2,25],$V9=[1,15],$Va=[1,16],$Vb=[1,17],$Vc=[1,18],$Vd=[1,19],$Ve=[1,20],$Vf=[1,21],$Vg=[1,22],$Vh=[1,23],$Vi=[1,24],$Vj=[1,25],$Vk=[1,26],$Vl=[1,27],$Vm=[1,31],$Vn=[1,32],$Vo=[1,33],$Vp=[1,34],$Vq=[1,35],$Vr=[1,36],$Vs=[1,37],$Vt=[5,6,13,14],$Vu=[2,34],$Vv=[1,40],$Vw=[5,6,13,14,36],$Vx=[1,42],$Vy=[1,43],$Vz=[1,53],$VA=[1,51],$VB=[1,52],$VC=[1,54],$VD=[1,47],$VE=[1,48],$VF=[1,49],$VG=[1,50],$VH=[1,55],$VI=[1,56],$VJ=[1,57],$VK=[5,6,13,14,29,36,38,39,40,41,42,43,44,45,46,47,48,49,50,57],$VL=[1,69],$VM=[1,59],$VN=[1,60],$VO=[1,61],$VP=[1,62],$VQ=[1,63],$VR=[1,64],$VS=[1,65],$VT=[1,66],$VU=[1,67],$VV=[1,68],$VW=[1,70],$VX=[1,71],$VY=[29,38,39,40,41,42,43,44,45,46,47,48,49,50,57],$VZ=[38,39,40,57],$V_=[38,39,40,41,42,43,44,45,46,57],$V$=[38,39,40,41,42,43,44,45,46,47,48,57];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"INICIO":3,"LISTA_CONSULTA":4,"EOF":5,"Simbolo_AND":6,"SECUENCIA":7,"RELATIVO_S":8,"AXIS":9,"POSICION":10,"PREDICADO":11,"RELATIVO":12,"Simbolo_Barra":13,"Simbolo_Barra_Doble":14,"Reservada_ancestor":15,"Reservada_ancestor-or-self":16,"Reservada_attribute":17,"Reservada_child":18,"Reservada_descendant":19,"Reservada_descendant-or-self":20,"Reservada_following":21,"Reservada_following-sibling":22,"Reservada_namespace":23,"Reservada_parent":24,"Reservada_preceding":25,"Reservada_preceding-sibling":26,"Reservada_self":27,"ID":28,"Simbolo_Asterisco":29,"Reservada_Node":30,"Reservada_Text":31,"Simbolo_Arroba":32,"SELECTF":33,"Simbolo_Punto":34,"Simbolo_Doble_Punto":35,"Simbolo_Abrir_Corchete":36,"VALOR":37,"Simbolo_Cerrar_Corchete":38,"Reservada_or":39,"Reservada_and":40,"Simbolo_Mayor":41,"Simbolo_Mayor_Igual":42,"Simbolo_Menor":43,"Simbolo_Menor_Igual":44,"Simbolo_Igual":45,"Simbolo_Distinto":46,"Simbolo_Mas":47,"Simbolo_Menos":48,"Reservada_div":49,"Reservada_mod":50,"VALORES":51,"Entero":52,"Decimal":53,"Reservada_last":54,"Reservada_position":55,"Simbolo_Abrir_Parentesis":56,"Simbolo_Cerrar_Parentesis":57,"Cadena":58,"Caracter":59,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"Simbolo_AND",13:"Simbolo_Barra",14:"Simbolo_Barra_Doble",15:"Reservada_ancestor",16:"Reservada_ancestor-or-self",17:"Reservada_attribute",18:"Reservada_child",19:"Reservada_descendant",20:"Reservada_descendant-or-self",21:"Reservada_following",22:"Reservada_following-sibling",23:"Reservada_namespace",24:"Reservada_parent",25:"Reservada_preceding",26:"Reservada_preceding-sibling",27:"Reservada_self",28:"ID",29:"Simbolo_Asterisco",30:"Reservada_Node",31:"Reservada_Text",32:"Simbolo_Arroba",34:"Simbolo_Punto",35:"Simbolo_Doble_Punto",36:"Simbolo_Abrir_Corchete",38:"Simbolo_Cerrar_Corchete",39:"Reservada_or",40:"Reservada_and",41:"Simbolo_Mayor",42:"Simbolo_Mayor_Igual",43:"Simbolo_Menor",44:"Simbolo_Menor_Igual",45:"Simbolo_Igual",46:"Simbolo_Distinto",47:"Simbolo_Mas",48:"Simbolo_Menos",49:"Reservada_div",50:"Reservada_mod",52:"Entero",53:"Decimal",54:"Reservada_last",55:"Reservada_position",56:"Simbolo_Abrir_Parentesis",57:"Simbolo_Cerrar_Parentesis",58:"Cadena",59:"Caracter"},
productions_: [0,[3,2],[3,2],[4,3],[4,1],[7,5],[7,4],[8,1],[8,1],[12,1],[12,1],[12,0],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,1],[9,0],[10,1],[10,1],[10,1],[10,1],[10,2],[10,1],[10,1],[11,3],[11,0],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,3],[37,1],[51,1],[51,1],[51,1],[51,1],[51,1],[51,1],[51,1],[51,2],[51,3],[51,1],[51,1],[33,1],[33,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

		this.$=new Nodo("Inicio","");
        this.$.Hijos.push($$[$0-1]);
        Raiz=this.$;
        var retorno={
			raiz:Raiz,
			Errores: ListaErrores,
			Consultas: ListaConsultas,
        };
        ListaErrores = new Array();
		ListaConsultas = new Array();
        return retorno;
	
break;
case 2:

        ListaErrores.push(new Error("Sintactico", yytext, "Token inesperado", this._$.first_line, this._$.first_column));
        this.$=new Nodo("Inicio","");
        Raiz=this.$;
        var retorno={
          raiz:Raiz,
          Errores: ListaErrores,
		  Consultas: ListaConsultas,
        };
        ListaErrores = new Array();
		ListaConsultas = new Array();
        return retorno;
      
break;
case 3:

					this.$=new Nodo("Lista_Consulta", "");
					this.$.Hijos.push($$[$0-2]);
					this.$.Hijos.push(new Nodo("|", ""));
					this.$.Hijos.push($$[$0]);
					ListaConsultas.push(Invertir($$[$0].Valor));
				
break;
case 4:

					this.$=new Nodo("Lista_Consulta", "");
					this.$.Hijos.push($$[$0]);
					ListaConsultas.push(Invertir($$[$0].Valor));
				
break;
case 5:

				this.$=new Nodo("Secuencia", "");
				this.$.Hijos.push($$[$0-4]);
				this.$.Hijos.push($$[$0-3]);
				this.$.Hijos.push($$[$0-2]);
				this.$.Hijos.push($$[$0-1]);
				this.$.Hijos.push($$[$0]);
				this.$.Valor = new Consulta($$[$0-3].Valor, $$[$0-2].Valor, $$[$0-1], $$[$0], $$[$0-4].Valor);
			
break;
case 6:

				this.$=new Nodo("Secuencia", "");
				this.$.Hijos.push($$[$0-3]);
				this.$.Hijos.push($$[$0-2]);
				this.$.Hijos.push($$[$0-1]);
				this.$.Hijos.push($$[$0]);
				this.$.Valor = new Consulta($$[$0-3].Valor, $$[$0-2].Valor, $$[$0-1], $$[$0], "");
			
break;
case 7:
this.$=new Nodo("Relativo_S", ""); this.$.Hijos.push(new Nodo("/", ""));
break;
case 8:
this.$=new Nodo("Relativo_S", ""); this.$.Hijos.push(new Nodo("//", ""));
break;
case 9:
this.$=new Nodo("Relativo", "/"); this.$.Hijos.push(new Nodo("/", ""));
break;
case 10:
this.$=new Nodo("Relativo", "//"); this.$.Hijos.push(new Nodo("//", ""));
break;
case 11:
this.$=new Nodo("Relativo", "");
break;
case 12:
this.$=new Nodo("Axis", "ancestor"); this.$.Hijos.push(new Nodo("ancestor", ""));
break;
case 13:
this.$=new Nodo("Axis", "ancestor-or-self"); this.$.Hijos.push(new Nodo("ancestor-or-self", ""));
break;
case 14:
this.$=new Nodo("Axis", "attribute"); this.$.Hijos.push(new Nodo("attribute", ""));
break;
case 15:
this.$=new Nodo("Axis", "child"); this.$.Hijos.push(new Nodo("child", ""));
break;
case 16:
this.$=new Nodo("Axis", "descendant"); this.$.Hijos.push(new Nodo("descendant", ""));
break;
case 17:
this.$=new Nodo("Axis", "descendant-or-self"); this.$.Hijos.push(new Nodo("descendant-or-self", ""));
break;
case 18:
this.$=new Nodo("Axis", "following"); this.$.Hijos.push(new Nodo("following", ""));
break;
case 19:
this.$=new Nodo("Axis", "following-sibling"); this.$.Hijos.push(new Nodo("following-sibling", ""));
break;
case 20:
this.$=new Nodo("Axis", "namespace"); this.$.Hijos.push(new Nodo("namespace", ""));
break;
case 21:
this.$=new Nodo("Axis", "parent"); this.$.Hijos.push(new Nodo("parent", ""));
break;
case 22:
this.$=new Nodo("Axis", "preceding"); this.$.Hijos.push(new Nodo("preceding", ""));
break;
case 23:
this.$=new Nodo("Axis", "preceding-sibling"); this.$.Hijos.push(new Nodo("preceding-sibling", ""));
break;
case 24:
this.$=new Nodo("Axis", "self"); this.$.Hijos.push(new Nodo("self", ""));
break;
case 25:
this.$=new Nodo("Axis", "");
break;
case 26:
this.$=new Nodo("Posicion", "ID"); this.$.Hijos.push(new Nodo("ID", $$[$0]));
break;
case 27:
this.$=new Nodo("Posicion", "*"); this.$.Hijos.push(new Nodo("*", ""));
break;
case 28:
this.$=new Nodo("Posicion", "node()"); this.$.Hijos.push(new Nodo("node()", ""));
break;
case 29:
this.$=new Nodo("Posicion", "Text()"); this.$.Hijos.push(new Nodo("Text()", ""));
break;
case 30:
this.$=new Nodo("Posicion", "@"); this.$.Hijos.push(new Nodo("@", "")); this.$.Hijos.push($$[$0]);
break;
case 31:
this.$=new Nodo("Posicion", "."); this.$.Hijos.push(new Nodo(".", ""));
break;
case 32:
this.$=new Nodo("Posicion", ".."); this.$.Hijos.push(new Nodo("..", ""));
break;
case 33:

				this.$=new Nodo("Predicado", $$[$0-1]);
				this.$.Hijos.push(new Nodo("[", ""));
				this.$.Hijos.push($$[$0-1]);
				this.$.Hijos.push(new Nodo("]", ""));
		   	
break;
case 34:
this.$=new Nodo("Predicado", "");
break;
case 35:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("or", "")); this.$.Hijos.push($$[$0]);
break;
case 36:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("and", "")); this.$.Hijos.push($$[$0]);
break;
case 37:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo(">", "")); this.$.Hijos.push($$[$0]);
break;
case 38:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo(">=", "")); this.$.Hijos.push($$[$0]);
break;
case 39:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("<", "")); this.$.Hijos.push($$[$0]);
break;
case 40:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("<=", "")); this.$.Hijos.push($$[$0]);
break;
case 41:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("=", "")); this.$.Hijos.push($$[$0]);
break;
case 42:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("!=", "")); this.$.Hijos.push($$[$0]);
break;
case 43:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("+", "")); this.$.Hijos.push($$[$0]);
break;
case 44:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("-", "")); this.$.Hijos.push($$[$0]);
break;
case 45:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("*", "")); this.$.Hijos.push($$[$0]);
break;
case 46:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("div", "")); this.$.Hijos.push($$[$0]);
break;
case 47:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0-2]); this.$.Hijos.push(new Nodo("mod", "")); this.$.Hijos.push($$[$0]);
break;
case 48:
this.$=new Nodo("VALOR", ""); this.$.Hijos.push($$[$0]);
break;
case 49: case 50:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("Entero", $$[$0]));
break;
case 51:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("last()", ""));
break;
case 52:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("position()", ""));
break;
case 53:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("node()", ""));
break;
case 54:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("text()", ""));
break;
case 55:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("ID", $$[$0]));
break;
case 56:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("@", "")); this.$.Hijos.push($$[$0]);
break;
case 57:

									this.$=new Nodo("Valores", "");
									this.$.Hijos.push(new Nodo("(", ""));
									this.$.Hijos.push($$[$0-1]);
									this.$.Hijos.push(new Nodo(")", ""));
								
break;
case 58: case 59:
this.$=new Nodo("Valores", ""); this.$.Hijos.push(new Nodo("Cadena", $$[$0]));
break;
case 60:
this.$=new Nodo("SelectF", ""); this.$.Hijos.push(new Nodo("ID", $$[$0]));
break;
case 61:
this.$=new Nodo("SelectF", ""); this.$.Hijos.push(new Nodo("*", ""));
break;
}
},
table: [o($V0,$V1,{3:1,4:2,7:4,12:5,2:[1,3],13:$V2,14:$V3}),{1:[3]},{5:[1,8],6:[1,9]},{5:[1,10]},o($V4,[2,4],{8:11,13:$V5,14:$V6}),o($V7,$V8,{9:14,15:$V9,16:$Va,17:$Vb,18:$Vc,19:$Vd,20:$Ve,21:$Vf,22:$Vg,23:$Vh,24:$Vi,25:$Vj,26:$Vk,27:$Vl}),o($V0,[2,9]),o($V0,[2,10]),{1:[2,1]},o($V0,$V1,{12:5,7:28,13:$V2,14:$V3}),{1:[2,2]},o($V7,$V8,{9:29,15:$V9,16:$Va,17:$Vb,18:$Vc,19:$Vd,20:$Ve,21:$Vf,22:$Vg,23:$Vh,24:$Vi,25:$Vj,26:$Vk,27:$Vl}),o($V0,[2,7]),o($V0,[2,8]),{10:30,28:$Vm,29:$Vn,30:$Vo,31:$Vp,32:$Vq,34:$Vr,35:$Vs},o($V7,[2,12]),o($V7,[2,13]),o($V7,[2,14]),o($V7,[2,15]),o($V7,[2,16]),o($V7,[2,17]),o($V7,[2,18]),o($V7,[2,19]),o($V7,[2,20]),o($V7,[2,21]),o($V7,[2,22]),o($V7,[2,23]),o($V7,[2,24]),o($V4,[2,3],{8:11,13:$V5,14:$V6}),{10:38,28:$Vm,29:$Vn,30:$Vo,31:$Vp,32:$Vq,34:$Vr,35:$Vs},o($Vt,$Vu,{11:39,36:$Vv}),o($Vw,[2,26]),o($Vw,[2,27]),o($Vw,[2,28]),o($Vw,[2,29]),{28:$Vx,29:$Vy,33:41},o($Vw,[2,31]),o($Vw,[2,32]),o($Vt,$Vu,{11:44,36:$Vv}),o($Vt,[2,6]),{28:$Vz,30:$VA,31:$VB,32:$VC,37:45,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},o($Vw,[2,30]),o($VK,[2,60]),o($VK,[2,61]),o($Vt,[2,5]),{29:$VL,38:[1,58],39:$VM,40:$VN,41:$VO,42:$VP,43:$VQ,44:$VR,45:$VS,46:$VT,47:$VU,48:$VV,49:$VW,50:$VX},o($VY,[2,48]),o($VY,[2,49]),o($VY,[2,50]),o($VY,[2,51]),o($VY,[2,52]),o($VY,[2,53]),o($VY,[2,54]),o($VY,[2,55]),{28:$Vx,29:$Vy,33:72},{28:$Vz,30:$VA,31:$VB,32:$VC,37:73,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},o($VY,[2,58]),o($VY,[2,59]),o($Vt,[2,33]),{28:$Vz,30:$VA,31:$VB,32:$VC,37:74,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:75,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:76,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:77,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:78,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:79,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:80,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:81,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:82,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:83,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:84,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:85,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},{28:$Vz,30:$VA,31:$VB,32:$VC,37:86,51:46,52:$VD,53:$VE,54:$VF,55:$VG,56:$VH,58:$VI,59:$VJ},o($VY,[2,56]),{29:$VL,39:$VM,40:$VN,41:$VO,42:$VP,43:$VQ,44:$VR,45:$VS,46:$VT,47:$VU,48:$VV,49:$VW,50:$VX,57:[1,87]},o($VZ,[2,35],{29:$VL,41:$VO,42:$VP,43:$VQ,44:$VR,45:$VS,46:$VT,47:$VU,48:$VV,49:$VW,50:$VX}),o($VZ,[2,36],{29:$VL,41:$VO,42:$VP,43:$VQ,44:$VR,45:$VS,46:$VT,47:$VU,48:$VV,49:$VW,50:$VX}),o($V_,[2,37],{29:$VL,47:$VU,48:$VV,49:$VW,50:$VX}),o($V_,[2,38],{29:$VL,47:$VU,48:$VV,49:$VW,50:$VX}),o($V_,[2,39],{29:$VL,47:$VU,48:$VV,49:$VW,50:$VX}),o($V_,[2,40],{29:$VL,47:$VU,48:$VV,49:$VW,50:$VX}),o($V_,[2,41],{29:$VL,47:$VU,48:$VV,49:$VW,50:$VX}),o($V_,[2,42],{29:$VL,47:$VU,48:$VV,49:$VW,50:$VX}),o($V$,[2,43],{29:$VL,49:$VW,50:$VX}),o($V$,[2,44],{29:$VL,49:$VW,50:$VX}),o($VY,[2,45]),o($VY,[2,46]),o($VY,[2,47]),o($VY,[2,57])],
defaultActions: {8:[2,1],10:[2,2]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse (input) {
    var self = this,
        stack = [0],
        tstack = [], // token stack
        vstack = [null], // semantic value stack
        lstack = [], // location stack
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;

    var args = lstack.slice.call(arguments, 1);

    //this.reductionCount = this.shiftCount = 0;

    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    // copy state
    for (var k in this.yy) {
      if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
        sharedState.yy[k] = this.yy[k];
      }
    }

    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);

    var ranges = lexer.options && lexer.options.ranges;

    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }

    function popStack (n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }

_token_stack:
    var lex = function () {
        var token;
        token = lexer.lex() || EOF;
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }

    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        // retreive state number from top of stack
        state = stack[stack.length - 1];

        // use default actions if available
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            // read action for current state and first input
            action = table[state] && table[state][symbol];
        }

_handle_error:
        // handle parse error
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var error_rule_depth;
            var errStr = '';

            // Return the rule stack depth where the nearest error rule can be found.
            // Return FALSE when no error recovery rule was found.
            function locateNearestErrorRecoveryRule(state) {
                var stack_probe = stack.length - 1;
                var depth = 0;

                // try to recover from error
                for(;;) {
                    // check for error recovery rule in this state
                    if ((TERROR.toString()) in table[state]) {
                        return depth;
                    }
                    if (state === 0 || stack_probe < 2) {
                        return false; // No suitable error recovery rule available.
                    }
                    stack_probe -= 2; // popStack(1): [symbol, action]
                    state = stack[stack_probe];
                    ++depth;
                }
            }

            if (!recovering) {
                // first see if there's any chance at hitting an error recovery rule:
                error_rule_depth = locateNearestErrorRecoveryRule(state);

                // Report error
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push("'"+this.terminals_[p]+"'");
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol)+ "'";
                } else {
                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                  (symbol == EOF ? "end of input" :
                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected,
                    recoverable: (error_rule_depth !== false)
                });
            } else if (preErrorSymbol !== EOF) {
                error_rule_depth = locateNearestErrorRecoveryRule(state);
            }

            // just recovered from another error
            if (recovering == 3) {
                if (symbol === EOF || preErrorSymbol === EOF) {
                    throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
                }

                // discard current lookahead and grab another
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                symbol = lex();
            }

            // try to recover from error
            if (error_rule_depth === false) {
                throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
            }
            popStack(error_rule_depth);

            preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
            symbol = TERROR;         // insert generic error symbol as new lookahead
            state = stack[stack.length-1];
            action = table[state] && table[state][TERROR];
            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
        }

        // this shouldn't happen, unless resolve defaults are off
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
        }

        switch (action[0]) {
            case 1: // shift
                //this.shiftCount++;

                stack.push(symbol);
                vstack.push(lexer.yytext);
                lstack.push(lexer.yylloc);
                stack.push(action[1]); // push state
                symbol = null;
                if (!preErrorSymbol) { // normal execution/no error
                    yyleng = lexer.yyleng;
                    yytext = lexer.yytext;
                    yylineno = lexer.yylineno;
                    yyloc = lexer.yylloc;
                    if (recovering > 0) {
                        recovering--;
                    }
                } else {
                    // error just occurred, resume old lookahead f/ before error
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;

            case 2:
                // reduce
                //this.reductionCount++;

                len = this.productions_[action[1]][1];

                // perform semantic action
                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                // default location, uses first token for firsts, last for lasts
                yyval._$ = {
                    first_line: lstack[lstack.length-(len||1)].first_line,
                    last_line: lstack[lstack.length-1].last_line,
                    first_column: lstack[lstack.length-(len||1)].first_column,
                    last_column: lstack[lstack.length-1].last_column
                };
                if (ranges) {
                  yyval._$.range = [lstack[lstack.length-(len||1)].range[0], lstack[lstack.length-1].range[1]];
                }
                r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));

                if (typeof r !== 'undefined') {
                    return r;
                }

                // pop off stack
                if (len) {
                    stack = stack.slice(0,-1*len*2);
                    vstack = vstack.slice(0, -1*len);
                    lstack = lstack.slice(0, -1*len);
                }

                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                // goto new state = table[STATE][NONTERMINAL]
                newState = table[stack[stack.length-2]][stack[stack.length-1]];
                stack.push(newState);
                break;

            case 3:
                // accept
                return true;
        }

    }

    return true;
}};

	const {Nodo} = require("../Expresiones/Nodo");
	const {Consulta} = require("../Expresiones/Consulta");
	const {Error} = require("../Expresiones/Error");

	var ListaAuxiliar = [];
	var Aux = "";

	function Invertir(Cabeza){
		ListaAuxiliar = new Array();
		Aux = Cabeza;
		while(Aux!=""){
			ListaAuxiliar.push(Aux);
			Aux = Aux.Secuencia;
		}
		ListaAuxiliar[0].Secuencia = "";
		for (var i = 1; i < ListaAuxiliar.length; i++) {
			ListaAuxiliar[i].Secuencia = ListaAuxiliar[i-1];
		}
		return ListaAuxiliar[ListaAuxiliar.length-1];
	}

	var ListaErrores = [];
	var ListaConsultas = [];
    var Raiz;

/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:// Espacios
break;
case 1:return 54;
break;
case 2:return 55;
break;
case 3:return 49;
break;
case 4:return 39;
break;
case 5:return 40;
break;
case 6:return 50;
break;
case 7:return 30;
break;
case 8:return 31;
break;
case 9:return 15;
break;
case 10:return 16;
break;
case 11:return 17;
break;
case 12:return 18;
break;
case 13:return 19;
break;
case 14:return 20;
break;
case 15:return 21;
break;
case 16:return 22;
break;
case 17:return 23;
break;
case 18:return 24;
break;
case 19:return 25;
break;
case 20:return 26;
break;
case 21:return 27;
break;
case 22:return 'Simbolo_Doble_AND';
break;
case 23:return 6;
break;
case 24:return 47;
break;
case 25:return 48;
break;
case 26:return 29;
break;
case 27:return 14;
break;
case 28:return 13;
break;
case 29:return 45;
break;
case 30:return 42;
break;
case 31:return 41;
break;
case 32:return 44;
break;
case 33:return 43;
break;
case 34:return 46;
break;
case 35:return 56;
break;
case 36:return 57;
break;
case 37:return 36;
break;
case 38:return 38;
break;
case 39:return 32;
break;
case 40:return 35;
break;
case 41:return 34;
break;
case 42:yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 58; 
break;
case 43:yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 59; 
break;
case 44:return 53;
break;
case 45:return 52;
break;
case 46:return 28;
break;
case 47:return 5;
break;
case 48:ListaErrores.push(new Error('Lexico', yy_.yytext, "Simbolo no perteneciente al lenguaje", yy_.yylloc.first_line, yy_.yylloc.first_column));
break;
}
},
rules: [/^(?:\s+)/i,/^(?:last\(\))/i,/^(?:position\(\))/i,/^(?:div\b)/i,/^(?:or\b)/i,/^(?:and\b)/i,/^(?:mod\b)/i,/^(?:node\(\))/i,/^(?:text\(\))/i,/^(?:ancestor::)/i,/^(?:ancestor-or-self::)/i,/^(?:attribute::)/i,/^(?:child::)/i,/^(?:descendant::)/i,/^(?:descendant-or-self::)/i,/^(?:following::)/i,/^(?:following-sibling::)/i,/^(?:namespace::)/i,/^(?:parent::)/i,/^(?:preceding::)/i,/^(?:preceding-sibling::)/i,/^(?:self::)/i,/^(?:\|\|)/i,/^(?:\|)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/\/)/i,/^(?:\/)/i,/^(?:=)/i,/^(?:>=)/i,/^(?:>)/i,/^(?:<=)/i,/^(?:<)/i,/^(?:!=)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\[)/i,/^(?:\])/i,/^(?:@)/i,/^(?:\.\.)/i,/^(?:\.)/i,/^(?:"[^\"]*")/i,/^(?:'[^\"]*')/i,/^(?:[0-9]+(\.[0-9]+)\b)/i,/^(?:[0-9]+\b)/i,/^(?:([a-zA-Z])[a-zA-Z0-9_]*)/i,/^(?:$)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = XPATH_A;
exports.Parser = XPATH_A.Parser;
exports.parse = function () { return XPATH_A.parse.apply(XPATH_A, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}